import React, { useState } from "react";
import moment from "moment";
import axios from "axios";
import { Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Tr, Td } from "react-super-responsive-table";
import {
  DeleteTwoTone,
  GetAppTwoTone,
  InfoTwoTone,
  PictureAsPdfTwoTone,
  DescriptionTwoTone,
} from "@material-ui/icons";
import { removeReport } from "../../store/actions/reportActions";
import DisallowedForRole from "../Users/DisallowedForRole";
import LCIconButton from "../styles/LCIconButton";
import { capitalize } from "../../lib/helpers";

const ActivityRow = ({ report, currentDomainId }) => {
  const dispatcher = useDispatch();
  const currentDomain = useSelector((state) => state.domains.currentDomain);
  const isLoading = useSelector((state) => state.config.disableButton);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const startDate = moment(report.startDate).format("MMMM Do YYYY");
  const endDate = moment(report.endDate).format("MMMM Do YYYY");
  const createdAt = moment(report.createdAt).format("MMMM Do YYYY");

  const downloadReport = (event) => {
    event.preventDefault();
    axios
      .get(`reports/${currentDomainId}/${report._id}`)
      .then((response) => {
        const data = response.data;
        if (report.format === "csv") {
          window.location = data.downloadLink;
        } else {
          window.open(data.downloadLink, "_blank");
        }
      })
      .catch((error) => {});
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    dispatcher(removeReport(currentDomain._id, report._id));
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  // const iconStyle = { fontSize: "26px", color: "#002f53" };

  return (
    <Tr className="ant-table-row ant-table-row-level-0">
      <Td className="ant-table-cell">
        {capitalize(report.type)} Ranking Report
      </Td>
      <Td className="ant-table-cell">{startDate}</Td>
      <Td className="ant-table-cell">{endDate}</Td>
      <Td className="ant-table-cell">
        {report.format === "pdf" ? (
          <PictureAsPdfTwoTone />
        ) : (
          <DescriptionTwoTone />
        )}
      </Td>
      <Td className="ant-table-cell">{createdAt}</Td>
      <Td className="ant-table-cell">
        {report.processing ? (
          <>Processing...</>
        ) : (
          <>
            {report.error ? (
              <span style={{ color: "darkred" }}>No Data Available</span>
            ) : (
              // <a href="#." onClick={downloadReport}>
              //   <GetAppTwoTone style={iconStyle} />
              // </a>
              <LCIconButton as="button" onClick={(e) => downloadReport(e)}>
                <GetAppTwoTone />
              </LCIconButton>
            )}
            <Modal
              title="Are you sure ?"
              visible={isModalVisible}
              onOk={handleOk}
              onCancel={handleCancel}
              okText="Confirm"
              keyboard={false}
              maskClosable={false}
              okButtonProps={{
                loading: isLoading,
                type: "danger",
              }}
            >
              <p>
                <InfoTwoTone style={{ color: "#f5222d" }} /> Once confirm report
                will be permanently deleted.
              </p>
            </Modal>
            <DisallowedForRole roles={["viewer"]}>
              <LCIconButton type="secondary" as="button" onClick={showModal}>
                <DeleteTwoTone />
              </LCIconButton>
            </DisallowedForRole>
          </>
        )}
      </Td>
    </Tr>
  );
};

export default ActivityRow;
